<template>
  <Modal :id="'cmp-multi-order-list'" @cancelled="onCancel">
    <template slot="header"></template>

    <template slot="body">
      <div class="cm-multi-order-list-container dbox">
        <NTable
          v-if="!next"
          :headers="headers"
          :items="list"
          class="multi-order-list h1 dbox1"
          :config="tableConfig"
          @scrollnext="onListScroll"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td v-bind="tdcon('artist')">
                <span>{{ item["bandcamp_items"][0].artist }}</span>
              </td>
              <td v-bind="tdcon('title1')">
                <span>{{ item["bandcamp_items"][0].item_name }}</span>
              </td>
              <td v-bind="tdcon('sku')">
                <span>{{ item["bandcamp_items"][0].sku }}</span>
              </td>
              <td v-bind="tdcon('catalog_no')">
                <Dropdown
                  id="catalog_no"
                  :options="productsTV"
                  class="search-container-dropdown"
                  isSearchable
                  :disabled="false"
                  :showLabel="false"
                  :selected="getSelected(item)"
                  @selectedChange="
                    (e) => onAutocompleteSelected('catalog_no', e, item)
                  "
                  @searched="onDropdownSearch"
                />
                <!-- <span>
                      {{item['bandcamp_items'][0].sub_total}}</span> -->
              </td>
            </tr>
          </template>
        </NTable>
        <BandCampModalMext v-else :bandCampData="bandCampData" />
      </div>

      <div class="cm-multi-order-list-container dbox">
        <NTable
          v-if="!next"
          :headers="headers"
          :items="list"
          class="multi-order-list h1 dbox1"
          :config="tableConfig"
          @scrollnext="onListScroll"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td v-bind="tdcon('artist')">
                <span>{{ item["bandcamp_items"][0].artist }}</span>
              </td>
              <td v-bind="tdcon('title1')">
                <span>{{ item["bandcamp_items"][0].item_name }}</span>
              </td>
              <td v-bind="tdcon('sku')">
                <span>{{ item["bandcamp_items"][0].sku }}</span>
              </td>
              <td v-bind="tdcon('catalog_no')">
                <Dropdown
                  id="catalog_no"
                  :options="productsTV"
                  class="search-container-dropdown"
                  isSearchable
                  :disabled="false"
                  :showLabel="false"
                  :selected="getSelected(item)"
                  @selectedChange="
                    (e) => onAutocompleteSelected('catalog_no', e, item)
                  "
                  @searched="onDropdownSearch"
                />
                <!-- <span>
                      {{item['bandcamp_items'][0].sub_total}}</span> -->
              </td>
            </tr>
          </template>
        </NTable>
        <BandCampModalMext v-else :bandCampData="bandCampData" />
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click="onCancel">Cancel</button>
      <button @click="onOKClick" class="dt-button v1 s6">OK</button>
    </template>
  </Modal>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as orderActionTypes from "../../store/orders/types";

import InputField from "../../../../plugins/text-field/input-field";
import Checkbox2 from "../../../../plugins/checkbox/checkbox-2";

import Modal from "../../../../dt-plugins/modal/modal";

import NTable from "@/plugins/datatable/datatable";
import { OrderService } from "../../services/order.service";
import { distributionOrderGetters } from "../../store/orders/getters";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { createTV } from "../../../../models/text-value.model";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import BandCampModalMext from "./bandcamp-modal-next.vue";
import { distributionOrderActions } from "../../store/orders/actions";

import { subscribeSubject } from "../../../../utility";
import { Subject } from "rxjs";
export default {
  props: {
    // bandCampData: {
    //     type: Object,
    // },
  },
  components: {
    InputField,
    Checkbox2,
    Modal,
    NTable,
    BandCampModalMext,
  },

  mounted: async function () {
    const resData = await OrderService.getProductForBandcampOrderModal(
      undefined
    );
    this.productsTV = createTV(
      resData.data.products,
      "catalog_no",
      "product_id"
    );
    this.bandcampList = this.bandCampData?.ordersArray.slice(0, 100) || [];
    subscribeSubject(this, this.scrollSubject, (res) => {
      this.bandcampList = [
        ...this.bandcampList,
        ...this.bandCampData?.ordersArray.slice(res.start, res.rowCount),
      ];
      console.log("STRING SER", res);
    });
  },
  watch: {},
  data: function () {
    return {
      style: {
        "margin-top": "15px",
      },

      scrollSubject: new Subject(),

      productsTV: [],
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      },
      selectedArray: [],
      next: false,
      bandcampList: [],
      rowCount: 100,
      start: 0,
    };
  },

  computed: {
    ...mapGetterObject(storeNS, distributionOrderGetters),
    bandCampData: function () {
      return this.distributionOrderList?.bandCampResponse || {};
    },

    list: function () {
      return this.bandcampList || [];
    },
    headers: function () {
      return [
        createTableHeader("artist", { f: 1 }),
        createTableHeader("title1", { text: "title", f: 2.5 }),
        createTableHeader("sku", { f: 1 }),
        createTableHeader("catalog_no", { f: 1 }),
      ];
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionOrderActions),

    onTextFieldValueChange: function (e) {},
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onOKClick: function () {
      this.next = true;
    },
    getSelected: function (item) {
      const selectedItem = this.selectedArray.find(
        (e) =>
          e.key ==
          `${item["bandcamp_items"][0].package_id}-${item["bandcamp_items"][0].payment_id}`
      );
      if (selectedItem) {
        return this.productsTV.find((e) => e.value == selectedItem.value);
      }

      return undefined;
    },

    onDropdownSearch: async function (e) {
      console.log(":::::", e);
      const resData = await OrderService.getProductForBandcampOrderModal(e);
      console.log("resData", resData);
      this.productsTV = createTV(
        resData.data.products,
        "catalog_no",
        "product_id"
      );
    },
    onAutocompleteSelected: function (name, value, item) {
      console.log(name, value);

      const key =
        item["bandcamp_items"][0].package_id +
        "-" +
        item["bandcamp_items"][0].payment_id;

      if (this.selectedArray.length > 0) {
        this.selectedArray = [
          ...this.selectedArray,
          { key: key, value: value.value },
        ];
      } else {
        this.selectedArray = [{ key: key, value: value.value }];
      }
    },
    onListScroll: function (value) {
      console.log("OOO");
      this.start = this.rowCount;
      this.rowCount += this.rowCount;

      this.scrollSubject.next({ rowCount: this.rowCount, start: this.start });
    },
  },
};
</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 100%;
  .search {
    margin-right: 10px;
    width: 250px;
  }
  .users-dropdown {
    width: 250px;
  }
}

.cm-multi-order-list-container {
  .multi-order-list {
    --ntable-height: 300px !important;
    --tb-layout: fixed;
    tr {
      padding-left: 5px;
    }
    td:last-child,
    th:last-child {
      width: 50px !important;
    }

    td.name {
      color: black !important;
      font-weight: 800 !important;
    }
  }

  .dt-table.ind-table {
    td:nth-child(5),
    th:nth-child(5) {
      width: 50px !important;
    }
  }
}
.contact-search {
  display: flex;
  margin: 20px;
  // flex-direction: row;
  // justify-content: stretch;
}
.fc2-checkbox {
  .dt-checkbox-container {
    .dt-checkbox {
      margin-top: 12px !important;
    }
  }
}

button {
  height: 2.5em;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border-radius: 5px;
}
</style>
